import { Box } from '../../ui';
import { MarkLoader } from './MarkLoader';

/** While the app starts: the mark grows, so a slow start says whose app it is. */
export function StartingScreen() {
  return (
    <Box
      styles={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
      }}
    >
      <MarkLoader motion="grow" size="start" />
    </Box>
  );
}
